import { useStartProcess } from "@/hooks/ai-tool-process/use-start-process";
import { useTextToMusicProgressContext } from "@/components/pages/text-to-music/components/providers/text-to-music-progress-provider";
import { textToMusicSessionStorage } from "@/services/storage/text-to-music-session-storage";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { LicenseName } from "@/data/license.data";

export type TextToMusicConfig = {
  text: string;
  trackLength: number;
};

const startTextToMusicConfigCreator = (
  textToMusicConfig: TextToMusicConfig,
) => {
  return {
    createConfigFormData: (formData: FormData) => {
      formData.append("text", textToMusicConfig.text);
      formData.append(
        "track_length",
        (textToMusicConfig.trackLength ?? 15).toString(),
      );
    },
  };
};

export const useStartTextToMusic = () => {
  const progressContext = useTextToMusicProgressContext();
  const { showModal } = useGlobalModalContext();
  const showLimitedModal = (licenseName: LicenseName) =>
    showModal({
      type: "text-to-music-count-limited_modal",
      props: {
        licenseName: licenseName,
      },
    });

  const { startAiProcess } = useStartProcess(
    (config: TextToMusicConfig) => startTextToMusicConfigCreator(config),
    textToMusicSessionStorage.pendingConfigStorage,
    "/api/text-to-music/file",
    progressContext,
    showLimitedModal,
  );

  return { startTextToMusic: startAiProcess };
};
